// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2484) return "static/chunks/2484-603959d30b439b39.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1160":"28d2f374adc59d8e","2327":"f1ee7a001103320e","3681":"10906efc282673e3","7335":"2bb591ccd538d4fe","7559":"185ea0db8206048a","8353":"d365c8e4bc739e3f"}[chunkId] + ".js";
};